import React from 'react';
import {
  Box,
  Button,
  Dialog,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { poppins400, poppins500 } from 'theme/common.style';
import dayjs from 'dayjs';
import { DownArrowRed, Uparrow } from './Marketplaceicons';
import moment from 'moment';
import { WarningLite } from '../BuyerRegistration/components/WarningLite';
import AdditionalConditionTooltip from 'component/Common/AdditionalConditionTooltip';
import NameTooltip from 'component/Common/NameTooltip';

const Warning = ({ matchesmd }) => {
  return (
    <svg
      width={matchesmd ? '25' : '38'}
      height={matchesmd ? '24' : '36'}
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#10D35E"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#10D35E"
      />
    </svg>
  );
};

const MakeOffersNewPopup = ({
  manageOfferData,
  vendorCounterOfferValue,
  setManageOfferData,
  vendorCounterOffer,
  matches380,
  offerSummary,
  setOfferSummary,
  getBuyerIndividualValue,
  matchessm,
  lastHighestOffers,
  indexs,
  setShowpopup,
  buyerOffers,
}) => {
  let formatteddate = dayjs(buyerOffers[indexs]?.createdAt).format(
    'HH:mm:ss DD-MM-YYYY'
  );

  const currentOffer = buyerOffers[indexs];
  const sortedOffers = [...buyerOffers].sort(
    (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
  );

  const firstOffer = sortedOffers.find(
    (offer) => offer?.buyerUniqueId == currentOffer?.buyerUniqueId
  );

  const isFirstOffer =
    currentOffer?.propertyOfferId == firstOffer?.propertyOfferId;

  const theme = useTheme();
  const matches400 = useMediaQuery(theme.breakpoints.down(400));

  const offerStatusLastUpdated = moment(
    getBuyerIndividualValue?.PropertyDetails?.offerStatus?.lastUpdated
  ).format('DD-MM-YYYY HH:mm');
  const counterOfferUpdatedTime = moment(
    vendorCounterOfferValue?.createdAt
  ).format('DD-MM-YYYY HH:mm');

  const summaryFont = {
    color: '#26344E',
    fontFamily: 'Poppins',
    fontWeight: 500,
    lineHeight: 'normal',
    fontSize: matches380 ? '12px' : '14px',
  };

  const shouldShowBuyerOffer =
    vendorCounterOfferValue?.buyerOfferPrice &&
    vendorCounterOfferValue?.buyerOfferPrice !== '-' &&
    !(
      vendorCounterOfferValue?.offerPrice &&
      vendorCounterOfferValue?.variance == null
    );

  return (
    <>
      <Dialog
        open={offerSummary}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '700px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            maxHeight: { lg: '88%', xl: '90%', xs: '92%' },
          },
        }}
      >
        <Grid container sx={{ padding: matchessm ? '10px' : '20px 30px' }}>
          <Grid item xs={12}>
            <Typography
              sx={{ ...poppins400, fontSize: '14px', color: '#666666' }}
            >
              {
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName
              }
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
            marginTop={'10px'}
            textAlign={'center'}
            justifyContent={'space-between'}
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Warning />
              <Typography
                sx={{
                  ...poppins500,
                  fontSize: matchessm ? '20px' : '24px',
                  paddingLeft: '12px',
                }}
              >
                {currentOffer?.isPrivate == 1
                  ? 'Vendor Private Offer Received'
                  : currentOffer?.isCounter == 1
                  ? 'Vendor Counter Offer Received'
                  : isFirstOffer
                  ? 'Offer Submitted Successfully'
                  : 'Offer Updated Successfully'}
              </Typography>
            </Box>
            {vendorCounterOffer &&
              (currentOffer?.isCounter === 1 ||
                currentOffer?.isPrivate === 1) && (
                <Box
                  sx={{
                    padding: '3px 10px',
                    border: `1px solid ${
                      currentOffer?.isCounter == 1
                        ? 'rgba(255, 0, 255, 1)'
                        : 'rgba(11, 168, 218, 1)'
                    }`,
                    color:
                      currentOffer?.isCounter == 1
                        ? 'rgba(255, 0, 255, 1)'
                        : 'rgba(11, 168, 218, 1)',
                    borderRadius: '17px',
                    flexWrap: 'nowrap',
                    whiteSpace: 'nowrap',
                    fontFamily: 'Poppins !important',
                    fontStyle: 'normal !important',
                    fontWeight: '300 !important',
                    fontSize: '12px !important',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    display: 'flex',
                    gap: 0.7,
                  }}
                >
                  <WarningLite
                    color={
                      currentOffer?.isCounter == 1
                        ? 'rgba(255, 0, 255, 1)'
                        : 'rgba(11, 168, 218, 1)'
                    }
                  />
                  {currentOffer?.isPrivate === 1
                    ? 'Private Offer'
                    : 'Counter Offer'}
                </Box>
              )}
          </Grid>
          <Typography
            sx={{
              fontFamily: 'poppins',
              fontSize: '14px',
              color: '#666666',
              paddingLeft: '12px',
              mt: 1,
            }}
          >
            {currentOffer?.isPrivate == 1
              ? 'You have received vendor private offer'
              : currentOffer?.isCounter == 1
              ? 'You have received vendor counter offer'
              : isFirstOffer
              ? 'Your offer has been submitted'
              : 'Your updated offer has been submitted'}
          </Typography>
          {vendorCounterOffer && (
            <Grid
              marginTop={'15px'}
              style={{
                display: 'flex',
                flexDirection: 'row',
                gap: matchessm ? '5px' : '20px',
                alignItems: 'center',
                justifyContent: matches400 ? 'space-between' : 'space-around',
                width: '100%',
              }}
            >
              {shouldShowBuyerOffer && (
                <Grid item sx={{ textAlign: 'center' }}>
                  <Box>
                    <Typography
                      sx={{
                        ...poppins500,
                        fontSize: matchessm ? '14px' : '24px',
                        color: '#112347',
                      }}
                    >
                      {vendorCounterOfferValue?.buyerOfferPrice}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: matches400 ? '8px' : '12px',
                        color: 'rgba(17, 35, 71, 0.5)',
                      }}
                    >
                      Last Updated :{' '}
                    </Typography>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: matches400 ? '8px' : '12px',
                        color: '#112347',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {offerStatusLastUpdated || '-'}
                    </Typography>
                  </Box>
                </Grid>
              )}

              {vendorCounterOfferValue?.variance != 0 &&
                vendorCounterOfferValue?.variance &&
                vendorCounterOfferValue?.variance != null && (
                  <Grid item sx={{ textAlign: 'center' }}>
                    {Math.round(vendorCounterOfferValue?.variance) < 0 ? (
                      <Typography
                        sx={{
                          ...poppins500,
                          fontSize: matches400 ? '10px' : '20px',
                          color: '#F93939',
                          whiteSpace: 'nowrap',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                        }}
                      >
                        {Math.abs(vendorCounterOfferValue?.variance)}%
                        <Box marginBottom={1.6}>
                          <DownArrowRed
                            width={matches400 ? '8' : '12'}
                            height={matches400 ? '16' : '26'}
                          />
                        </Box>
                      </Typography>
                    ) : (
                      <Typography
                        sx={{
                          ...poppins500,
                          fontSize: matches400 ? '10px' : '20px',
                          color: 'rgba(16, 211, 94, 1)',
                          whiteSpace: 'nowrap',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '4px',
                        }}
                      >
                        {Math.round(vendorCounterOfferValue?.variance)}%
                        <Box marginBottom={1.6}>
                          <Uparrow
                            width={matches400 ? '8' : '12'}
                            height={matches400 ? '16' : '26'}
                          />
                        </Box>
                      </Typography>
                    )}
                  </Grid>
                )}

              {vendorCounterOfferValue?.variance === 0 &&
                vendorCounterOfferValue?.buyerOfferPrice !== null && (
                  <Grid item sx={{ textAlign: 'center' }}>
                    <Typography
                      sx={{
                        ...poppins500,
                        fontSize: matches400 ? '10px' : '40px',
                        color: 'rgba(16, 211, 94, 1)',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      <Box component="span" sx={{ fontFamily: 'Arial' }}>
                        ≈
                      </Box>
                    </Typography>
                  </Grid>
                )}
              {vendorCounterOfferValue?.offerPrice && (
                <Grid item sx={{ textAlign: 'center' }}>
                  <Box>
                    <Typography
                      sx={{
                        ...poppins500,
                        fontSize: matchessm ? '14px' : '24px',
                        color: '#112347',
                      }}
                    >
                      {vendorCounterOfferValue?.offerPrice || '-'}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: matches400 ? '8px' : '12px',
                        color: 'rgba(17, 35, 71, 0.5)',
                      }}
                    >
                      Last Updated :{' '}
                    </Typography>
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: matches400 ? '8px' : '12px',
                        color: '#112347',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {counterOfferUpdatedTime || '-'}
                    </Typography>
                  </Box>
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
        <Divider sx={{ mt: { xs: 0.5, sm: -2, md: -2, lg: -2 } }}></Divider>
        <Grid
          container
          sx={{
            padding: '20px 30px',
            mt:
              buyerOffers[indexs]?.isPrivate == 1 ||
              buyerOffers[indexs]?.isCounter == 1
                ? 0
                : -2.5,
          }}
        >
          {!(
            buyerOffers[indexs]?.isPrivate == 1 ||
            buyerOffers[indexs]?.isCounter == 1
          ) && (
            <Grid xs={12} sx={{ textAlign: 'right' }}>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontSize: matchessm ? '10px' : '14px',
                  color: '#666666',
                }}
              >
                {formatteddate}
              </Typography>
            </Grid>
          )}
          <Grid
            container
            sx={{ display: ' flex', flexDirection: 'row' }}
            xs={12}
          >
            <Grid
              sx={{ display: 'flex', flexDirection: 'column', gap: '14px' }}
              xs={7}
            >
              <Typography sx={summaryFont}>
                <span style={{ marginRight: '70px' }}>Buyer:</span>

                <NameTooltip
                  name={manageOfferData?.buyerDetails?.buyerName || ''}
                  surname={manageOfferData?.buyerDetails?.buyerSurName || ''}
                >
                  <Typography
                    component="span"
                    sx={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      cursor: 'pointer',
                    }}
                  >
                    {`${manageOfferData?.buyerDetails?.buyerName || ''} ${
                      manageOfferData?.buyerDetails?.buyerSurName || ''
                    }`.trim()}
                  </Typography>
                </NameTooltip>
              </Typography>
              <Typography sx={summaryFont}>
                <span style={{ marginRight: '75px' }}>Offer:</span>{' '}
                {buyerOffers[indexs]?.buyerOfferPrice != null
                  ? buyerOffers[indexs]?.buyerOfferPrice
                  : buyerOffers[indexs]?.isPrivate == 1 ||
                    buyerOffers[indexs]?.isCounter == 1
                  ? buyerOffers[indexs]?.offerPrice
                  : buyerOffers[indexs]?.offerPrice}
              </Typography>
              <Typography sx={summaryFont}>
                <span style={{ marginRight: '25px' }}>Offer Terms:</span>
                <Typography
                  sx={{
                    color: 'white',
                    fontFamily: 'Poppins',
                    fontWeight: 500,
                    lineHeight: 'normal',
                    fontSize: matches380 ? '12px' : '14px',
                    background:
                      buyerOffers[indexs]?.buyerOfferPrice == null &&
                      (buyerOffers[indexs]?.isPrivate == 1 ||
                        buyerOffers[indexs]?.isCounter == 1)
                        ? buyerOffers[indexs]?.isConditional == 1
                          ? 'rgba(237, 11, 11, 0.60)'
                          : '#10D35E'
                        : buyerOffers[indexs]?.logIsConditional == 1
                        ? 'rgba(237, 11, 11, 0.60)'
                        : '#10D35E',
                    padding: '3px 5px',
                    borderRadius: '5px',
                  }}
                >
                  {buyerOffers[indexs]?.buyerOfferPrice == null &&
                  (buyerOffers[indexs]?.isPrivate == 1 ||
                    buyerOffers[indexs]?.isCounter == 1)
                    ? buyerOffers[indexs]?.isConditional == 1
                      ? 'Conditional'
                      : 'Unconditional'
                    : buyerOffers[indexs]?.logIsConditional == 1
                    ? 'Conditional'
                    : 'Unconditional'}
                </Typography>
              </Typography>
            </Grid>
            {buyerOffers[indexs]?.buyerOfferPrice != null &&
              (buyerOffers[indexs]?.isPrivate == 1 ||
                buyerOffers[indexs]?.isCounter == 1) && (
                <Grid
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '14px',
                    mt: '20px',
                  }}
                  xs={5}
                >
                  <Typography sx={summaryFont}></Typography>
                  <Typography sx={summaryFont}>
                    <span style={{ marginRight: '75px' }}>Offer:</span>{' '}
                    {buyerOffers[indexs]?.offerPrice ?? '-'}
                  </Typography>

                  <Typography sx={summaryFont}>
                    <span style={{ marginRight: '25px' }}>Offer Terms:</span>
                    <Typography
                      sx={{
                        color: 'white',
                        fontFamily: 'Poppins',
                        fontWeight: 500,
                        lineHeight: 'normal',
                        fontSize: matches380 ? '12px' : '14px',
                        background:
                          buyerOffers[indexs]?.isConditional == 1
                            ? 'rgba(237, 11, 11, 0.60)'
                            : '#10D35E',
                        padding: '3px 5px',
                        borderRadius: '5px',
                      }}
                    >
                      {buyerOffers[indexs]?.isConditional == 1
                        ? 'Conditional'
                        : 'Unconditional'}
                    </Typography>
                  </Typography>
                </Grid>
              )}
          </Grid>
        </Grid>
        {buyerOffers[indexs]?.conditionalTerms != '' && (
          <Grid sx={{ padding: '15px', mt: -5.5 }}>
            <Grid
              container
              sx={{
                display: 'flex',
                gap: { xs: '15px', md: '12px', lg: '12px', xl: '12px' },
                flexDirection: 'row',
                justifyContent: 'start',
                marginTop: '10px',
                padding: '10px',
                width: { md: '100%', sm: '100%' },
              }}
            >
              {buyerOffers[indexs]?.conditionalTerms?.map((item, index) => {
                const isAdditionalCondition =
                  item.conditionSubjectCode === 'SubtoAdd001';

                return (
                  <AdditionalConditionTooltip
                    key={`${item.conditionSubjectCode}-${index}`}
                    comment={item.additionalCondition}
                    disabled={!isAdditionalCondition}
                  >
                    <Grid
                      xs={5.69}
                      sm={3.8}
                      md={3.85}
                      lg={3.85}
                      item
                      sx={{
                        borderRadius: '8px',
                        border: '1px solid #DFDFDF',
                        background: '#FFF',
                        minHeight: '92px',
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'space-around',
                        padding: 2,
                        cursor: isAdditionalCondition ? 'pointer' : 'default',
                      }}
                    >
                      <Box
                        marginTop="5px"
                        padding={2}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {item.conditionSubjectCode === 'SubtoDep001' ? (
                          <Typography
                            sx={{
                              fontSize: '32px',
                              color: '#666666',
                              fontFamily: 'Poppins',
                            }}
                          >
                            {item.conditionSubjectFile}%
                          </Typography>
                        ) : item.conditionSubjectCode === 'SubtoSettle001' ? (
                          <Typography
                            sx={{
                              fontSize: '32px',
                              color: '#666666',
                              fontFamily: 'Poppins',
                            }}
                          >
                            {item.conditionSubjectFile}
                          </Typography>
                        ) : (
                          <img
                            src={item.conditionSubjectFile}
                            alt="condition"
                            width="40"
                            height="50"
                            style={{
                              objectFit: 'contain',
                            }}
                          />
                        )}
                      </Box>

                      <Grid
                        sx={{
                          fontSize: matchessm ? '10px' : '12px',
                          width: matchessm ? '100%' : '110px',
                          color: '#666',
                          textAlign: 'center',
                          fontFamily: 'Poppins',
                          fontStyle: 'normal',
                          fontWeight: 400,
                          lineHeight: 'normal',
                          minHeight: '36px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        {item.conditionSubjectValue}
                      </Grid>
                    </Grid>
                  </AdditionalConditionTooltip>
                );
              })}
            </Grid>
          </Grid>
        )}
        <Grid
          container
          sx={{
            display: 'flex',
            justifyContent: 'end',
            mt: { xs: -3, xl: -3, sm: -3, lg: -3 },
            mb: manageOfferData?.conditionList != '' ? 0 : 0,
          }}
        >
          <Button
            variant="contained"
            sx={{
              width: 'min-content',
              padding: '10px 35px',
              fontSize: '14px',
              margin: '20px',
              textTransform: 'capitalize',
              fontFamily: 'poppins',
            }}
            onClick={() => {
              setOfferSummary(false);
              setShowpopup(false);
            }}
          >
            close
          </Button>
        </Grid>
      </Dialog>
    </>
  );
};

export default MakeOffersNewPopup;
